module.exports = __webpack_public_path__ + "static/media/img-boxfit-thumb@3x.7afbef73.png";